import {
  containerWithGutters,
  createGrid,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const grid = createGrid({
  numberOfColumns: 12,
  rowGapSmall: 16,
  rowGapMedium: 16,
  rowGapLarge: 24,
  rowGapXLarge: 24,
});

export const wrapper = css`
  margin: 0 0 ${spacing.xxl}px;
`;

export const maxWidthContainer = css`
  margin: 0 auto;
  ${containerWithGutters};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      max-width: 1210px;
    `,
  )};
`;

export const productTitle = css`
  margin: 0;
  ${responsiveText.HEADING.LG};
`;

export const heading = css`
  margin: 0 0 ${spacing.xl}px;
  ${responsiveText.HEADING.SM};
`;

export const breadcrumbsContainer = css`
  margin: ${spacing.md}px auto;
`;

export const largeSpacingBottom = css`
  margin-bottom: ${spacing.xxl}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-bottom: ${spacing.xxl + spacing.base}px;
    `,
  )}
`;

export const partnerModules = css`
  background-color: color-mix(in srgb, ${palette.blueBase} 5%, white);
  margin-top: ${spacing.xxl + spacing.md}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-top: ${spacing.xxl + spacing.lg}px;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin-top: ${spacing.xxl + spacing.xl}px;
    `,
  )}
`;

export const partnerProductsCarousel = css`
  margin-top: ${spacing.xl}px;
`;

export const spanAcrossRows = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-row: 1 / span 7;
    `,
  )}
`;

export const widerColumn = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 7;
    `,
  )}
`;

export const narrowColumn = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 5;
    `,
  )}
`;

export const sectionHeading = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveText.HEADING.SM};
  margin: ${spacing.lg}px 0 ${spacing.xs}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: ${spacing.md}px 0 ${spacing.sm}px;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${spacing.md}px 0 ${spacing.md}px;
    `,
  )}
`;

export const overallRatingWrapper = css`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.lg}px;
`;

export const productReviewsWrapper = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-row: 1;
      grid-column: 1 / span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 1 / span 8;
    `,
  )}
`;
